import styled from 'styled-components';

import { Headline } from 'components/Headline';

import { pickColor } from 'themes/helpers/pickColor';

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  height: 1.9rem;
`;

const Label = styled.label`
  font-weight: 600;
  font-family: 'LFT Zeno', sans-serif;
  font-size: 1.2rem;

  text-transform: capitalize;

  white-space: nowrap;

  color: ${pickColor('black')};
`;

const Required = styled(Headline)`
  position: absolute;
  left: -10px;
`;

const ErrorMessage = styled(Headline)`
  margin-left: 1.2rem;

  white-space: nowrap;
`;

export { Header, Label, ErrorMessage, Required };
